// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/root/workspace/fine_digit_camp_webui/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "exact": false,
    "component": require('@/layouts/backend').default,
    "path": "/v2/console",
    "title": "打卡营后台",
    "breadName": "打卡营后台",
    "routes": [
      {
        "exact": true,
        "path": "/v2/console/access",
        "title": "权限管理",
        "component": require('@/pages/backend/PermissionConfig').default,
        "nav": true,
        "breadName": "权限管理"
      },
      {
        "exact": true,
        "path": "/v2/console/campsetings",
        "title": "打卡营设置",
        "component": require('@/pages/backend/cardCamp').default,
        "breadName": "打卡营设置"
      },
      {
        "exact": true,
        "path": "/v2/console/campsetings/:id",
        "title": "打卡营设置",
        "component": require('@/pages/backend/cardCampSettings').default
      },
      {
        "exact": false,
        "path": "/v2/console/questionbank",
        "title": "题库管理",
        "component": require('@/pages/backend/QuestionSettings').default,
        "breadName": "题库管理"
      }
    ]
  },
  {
    "exact": false,
    "path": "/v2",
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "exact": false,
        "path": "/v2",
        "component": require('@/layouts/eduHeader').default,
        "routes": [
          {
            "exact": true,
            "path": "/v2/camp",
            "title": "打卡营 - 帆软学院",
            "component": require('@/pages/camp/campIndex').default
          },
          {
            "exact": true,
            "path": "/v2/camp/marking",
            "title": "打卡营习题批阅 - 帆软学院",
            "component": require('@/pages/camp/marking').default
          },
          {
            "exact": true,
            "path": "/v2/camp/:id",
            "title": "打卡营招生页 - 帆软学院",
            "component": require('@/pages/camp/enrollStudentPage').default
          },
          {
            "exact": true,
            "path": "/v2/camp/class/:id",
            "title": "打卡营详情页 - 帆软学院",
            "component": require('@/pages/camp/campDetails').default
          },
          {
            "exact": true,
            "path": "/v2/camp/study/:id",
            "title": "打卡营学习页 - 帆软学院",
            "component": require('@/pages/camp/campStudyMain').default
          },
          {
            "exact": true,
            "path": "/v2/camp/manage/:id",
            "title": "心得管理 - 帆软学院",
            "component": require('@/pages/camp/manage/manageTabs').default
          },
          {
            "exact": true,
            "path": "/v2/camp/html2/test",
            "title": "test - 帆软学院",
            "component": require('@/test/test').default
          }
        ]
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
